import * as React from "react";

import { cn, tailwind } from "@/utilities/tailwind-utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(tailwind.components.input, className)}
      {...props}
    />
  );
}

export { Input };
